import React from 'react';
import { useNavigate } from 'react-router-dom';
import './RealisationsPage.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';

function RealisationsPage() {
    const navigate = useNavigate();

    return (
        <div className="realisations-page">
            <Header />

            {/* Hero Section */}
            <section className="realisations-hero">
                <div className="realisations-hero-background">
                    <img src="/slide1.png" alt="Octopus Background" className="realisations-hero-octopus-left" />
                    <img src="/slide1.png" alt="Octopus Background" className="realisations-hero-octopus-right" />
                </div>
                <div className="realisations-hero-container">
                    <h1 className="realisations-hero-title">
                        Le portfolio <span className="realisations-hero-highlight">intelligent</span> de notre agence digitale
                    </h1>
                    <p className="realisations-hero-description">
                        Chez Viviworks.AI, chaque projet est une fusion parfaite entre intelligence artificielle et expertise humaine. 
                        Nous concevons des projets web, des études de cas et des stratégies marketing qui combinent innovation technologique 
                        et créativité. Notre approche unique intègre l'IA pour optimiser chaque aspect de votre présence digitale, 
                        transformant vos ambitions en résultats concrets et mesurables.
                    </p>
                    <button className="realisations-hero-button" onClick={() => navigate('/contact')}>
                        Contactez nous dès maintenant
                    </button>
                </div>
            </section>

            {/* Études de cas IA Section */}
            <section className="realisations-cas-section">
                <div className="realisations-cas-container">
                    <div className="realisations-cas-left">
                        <h2 className="realisations-cas-title">
                            Études de cas IA : Des stratégies pilotées par <span className="realisations-highlight">la donnée</span>
                        </h2>
                        <p className="realisations-cas-description">
                            Nos études de cas illustrent comment l'intelligence artificielle transforme les stratégies digitales en succès mesurables. 
                            Grâce à l'analyse prédictive et à l'optimisation automatisée, nous aidons nos clients à atteindre des performances exceptionnelles. 
                            Chaque étude de cas présente une méthodologie basée sur la donnée, avec des résultats concrets en matière de visibilité, 
                            d'engagement et de conversion.
                        </p>
                        <button className="realisations-cas-button">
                            Découvrir nos articles
                        </button>
                    </div>

                    <div className="realisations-cas-right">
                        <div className="realisations-cas-card">
                            <h3 className="realisations-cas-card-title">
                                CAS 1: OPTIMISATION DU PARCOURS CLIENT POUR UNE MARQUE E-COMMERCE
                            </h3>
                            <p className="realisations-cas-card-text">
                                Grâce à l'analyse comportementale assistée par IA, nous avons optimisé le parcours client d'une marque e-commerce, 
                                résultant en une augmentation de 35% de conversion. L'IA a permis d'identifier les points de friction et d'anticiper 
                                les besoins des visiteurs, créant une expérience personnalisée et fluide.
                            </p>
                            <button type="button" className="realisations-cas-card-link">Voir l'étude de cas</button>
                        </div>

                        <div className="realisations-cas-card">
                            <h3 className="realisations-cas-card-title">
                                CAS 2: ANALYSE DE SENTIMENT ET AJUSTEMENT DE STRATÉGIE SOCIALE
                            </h3>
                            <p className="realisations-cas-card-text">
                                En utilisant l'analyse de sentiment par IA sur les réseaux sociaux, nous avons ajusté la stratégie de communication 
                                d'une entreprise, générant une hausse de 60% de l'engagement. L'IA a analysé des milliers de commentaires en temps réel, 
                                permettant des ajustements stratégiques immédiats et ciblés.
                            </p>
                            <button type="button" className="realisations-cas-card-link">Voir l'étude de cas</button>
                        </div>
                    </div>
                </div>
            </section>

            {/* Portfolio de projets Section */}
            <section className="realisations-portfolio-section">
                <div className="realisations-portfolio-container">
                    <div className="realisations-portfolio-left">
                        <div className="realisations-portfolio-card realisations-portfolio-card-pink">
                            <div className="realisations-portfolio-card-image">
                                <img src="/Frame 55.png" alt="Site vitrine" className="portfolio-card-img" />
                            </div>
                            <h3 className="realisations-portfolio-card-title">
                                SITE VITRINE DYNAMIQUE POUR UNE ENTREPRISE ÉLECTRONIQUE
                            </h3>
                            <p className="realisations-portfolio-card-description">
                                Conception d'un site web immersif intégrant un chatbot conversationnel intelligent pour guider les visiteurs dans la recherche d'offres personnalisées.
                            </p>
                            <button type="button" className="realisations-portfolio-card-link">Voir le projet</button>
                        </div>

                        <div className="realisations-portfolio-card realisations-portfolio-card-white">
                            <div className="realisations-portfolio-card-image">
                                <img src="/Frame 55 (1).png" alt="Campagne publicitaire" className="portfolio-card-img" />
                            </div>
                            <h3 className="realisations-portfolio-card-title realisations-portfolio-card-title-dark">
                                CAMPAGNE PUBLICITAIRE ADAPTATIVE SUR LES RÉSEAUX SOCIAUX
                            </h3>
                            <p className="realisations-portfolio-card-description realisations-portfolio-card-description-dark">
                                Développement d'une campagne social media pilotée par IA, capable d'analyser les interactions et d'ajuster automatiquement les visuels et messages selon les performances.
                            </p>
                            <button type="button" className="realisations-portfolio-card-link realisations-portfolio-card-link-dark">Voir le projet</button>
                        </div>
                    </div>

                    <div className="realisations-portfolio-right">
                        <h2 className="realisations-portfolio-title">
                            Portfolio de projets : Quand <span className="realisations-highlight">créativité et IA</span> se rencontrent
                        </h2>
                        <p className="realisations-portfolio-description">
                            Notre portfolio présente des projets web et marketing où la créativité humaine rencontre l'intelligence artificielle. 
                            Chaque projet intègre l'IA pour optimiser la performance, améliorer la navigation, renforcer le SEO et créer des campagnes 
                            digitales adaptatives. Découvrez comment nous combinons innovation technologique et design pour créer des expériences 
                            digitales exceptionnelles.
                        </p>
                        <button className="realisations-portfolio-button">
                            Découvrir nos projets
                        </button>
                    </div>
                </div>
            </section>

            {/* Final CTA Section */}
            <section className="realisations-final-cta">
                <div className="realisations-final-cta-container">
                    <h2 className="realisations-final-cta-title">
                        Faites partie de nos prochaines <span className="realisations-highlight">réussites IA</span>
                    </h2>
                    <p className="realisations-final-cta-description">
                        Prêt à transformer vos ambitions digitales en réalité ? Contactez Viviworks.AI et découvrez comment l'intelligence artificielle 
                        peut propulser votre entreprise vers de nouveaux sommets. Notre équipe combine données, créativité et technologie pour créer 
                        des solutions digitales qui génèrent des résultats concrets et mesurables.
                    </p>
                    <button className="realisations-final-cta-button" onClick={() => navigate('/contact')}>
                        Contactez nous dès maintenant
                    </button>
                </div>
            </section>

            <Footer />
            <ScrollToTop />
        </div>
    );
}

export default RealisationsPage;
